import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderSlot as _renderSlot, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b8b2a98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row my-4 gap-y-2" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "col-md-8 col-xl-9 mx-auto" }
const _hoisted_5 = {
  key: 0,
  class: "display-4"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mb-0 mt-2" }, null, -1))
const _hoisted_7 = { class: "text-color-secondary text-right mb-2" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["alt"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 2,
  class: "article-block"
}
const _hoisted_12 = {
  key: 0,
  class: "col-md-4 col-xl-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackButton = _resolveComponent("BackButton")!
  const _component_AuthorBlock = _resolveComponent("AuthorBlock")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_BackButton, {
          label: _ctx.$t('common.back')
        }, null, 8, ["label"])
      ]),
      _createElementVNode("article", _hoisted_4, [
        (_ctx.vm.title)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_5, _toDisplayString(_ctx.vm.title), 1))
          : _createCommentVNode("", true),
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("small", null, _toDisplayString(_ctx.formatLongDate(_ctx.vm.publishedOn)), 1)
        ]),
        _createElementVNode("p", {
          class: "lead",
          innerHTML: _ctx.vm.intro
        }, null, 8, _hoisted_8),
        (_ctx.vm.image)
          ? _withDirectives((_openBlock(), _createElementBlock("img", {
              key: 1,
              alt: _ctx.vm.image?.alt,
              class: "content-image"
            }, null, 8, _hoisted_9)), [
              [_directive_lazy, _ctx.vm.image?.url]
            ])
          : _createCommentVNode("", true),
        _createElementVNode("p", {
          class: "rte",
          innerHTML: _ctx.vm?.body
        }, null, 8, _hoisted_10),
        (_ctx.$slots.default)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _renderSlot(_ctx.$slots, "default", {}, undefined, true)
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.vm.author)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", {
              class: _normalizeClass({ 'sticky-sidebar': !_ctx.isSmallScreen })
            }, [
              _createVNode(_component_AuthorBlock, {
                vm: _ctx.vm.author
              }, null, 8, ["vm"])
            ], 2)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}